class AlertMessage {
    constructor() {
        this.alertContainer = document.querySelector('.alert-message');
        if (!this.alertContainer) {
            return;
        }

        this.closeBtn = this.alertContainer.querySelector('.close-btn');

        this.bindEvent();
    }

    removeAlertNotice() {
        this.alertContainer.classList.add('hide');
    }

    delayedAlertNoticeRemove(delay) {
        return new Promise(resolve => setTimeout(resolve, delay));
    }


    bindEvent() {
        this.closeBtn.addEventListener('click', () => {
            this.removeAlertNotice();
        });

        this.delayedAlertNoticeRemove(8000).then(() => {
            this.removeAlertNotice();
        });
    }
}